import { Box } from "@twilio-paste/core/box";
import * as React from "react";
import type { TableOfContentsHeaderProps } from "./types";

export const TableOfContentsHeader: React.FC<TableOfContentsHeaderProps> = ({ children, ...props }) => (
    <Box
        {...props}
        as="div"
        data-cy="page-aside-anchor"
        color="colorTextWeak"
        textDecoration="none"
        display="inline-block"
        width="100%"
        borderLeftColor="transparent"
        borderLeftStyle="solid"
        borderLeftWidth="borderWidth20"
        paddingTop="space50"
    >
        {children}
    </Box>
);
